import React, { FC, useContext, useEffect } from 'react';
//import Card from '@mui/material/Card';
//import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
//import Link from '@mui/material/Link';
import { Chip, Tooltip, /*Box,  Tooltip, Divider, Stack, Paper, SvgIcon*/ } from '@mui/material';
import PlaceIcon from '@mui/icons-material/Place';
//import { green } from '@mui/material/colors';
//import Grid from '@mui/material/Grid';
//import { GetPinIcon, GetPinName } from '../map/MapFilter'
import { useDispatch } from 'react-redux';
import { getSearchByCoordinates } from "../../features/searchSlice";
import Button from '@mui/material/Button';
//import { ReactComponent as CaregiverSVG } from '../../assets/caregiver.svg';
//import { ReactComponent as MMWarriorSVG } from '../../assets/patienticon.svg';
import { Stack } from '@mui/material';
//import Container from '@mui/material/Container';
import { setAnalyticUsersClicked, /*leocentersetCenter,*/ setPublicPinClicked } from "../../features/dataProcessingSlice"
import { GetUserTypePin } from '../MessageProfile'
import { activateMarker } from '../../features/activeMarkers';
import { AISummaryContext } from '../AI/AISummary';
import { DirectChatUsers, useSetChatUserMutation } from '../../features/ChatSlice';
import { StartChat } from '../markers/MMMarkers';
import { useNavigate } from 'react-router-dom';
import { useAuthProfile } from '../../app/hooks';
import LoadingButton from '@mui/material/Button'
import ChatIcon from '@mui/icons-material/Chat';

export interface CareCenterInfo {
    center_name: string,
    cancer_center_type: string,
    designation: string,
    address: string,
    lat: number,
    lng: number,
    street: string,
    city: string,
    state: string,
    region: string,
    country: string,
    phone: string,
    website: string,
    id: number,
    distance: number,
    count_in_radius: number,
    count_total: number
}

export interface PatientCardProps {
    patientInfo: any,
    align: string,
    compact?: boolean,
}

export const PatientCard: FC<PatientCardProps> = ({ patientInfo, align, compact = false }) => {
    const { showViewUserStoryAnalytics, showMessageButton, chatMode } = useContext(AISummaryContext);
    const { authStatus, profile: profileLoggedIn, isLoading: isLoadingpProfileLoggedIn, isLoading: isLoadingProfileLoggedIn, isError: isErrorProfileLoggedIn, error: errorProfileLoggedIn, /*userAttributesStateStatus */ } = useAuthProfile()
    const [SetChat, { isLoading: isLoadingSetChat, isSuccess: isSuccessSetChat, isError: isErrorSetChat, error: errorSetChat, data: setChatData, reset }] = useSetChatUserMutation()
    const navigate = useNavigate()
    const dispatch = useDispatch<any>()
    const distanceInMiles = (patientInfo.distance ?? 0) / 1609.34;
    const formattedNumber = new Intl.NumberFormat('en-US', {
        style: 'decimal',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    }).format(distanceInMiles);

    function handleProfileClick() {
        if (!chatMode) {
            dispatch(getSearchByCoordinates({ lat: patientInfo.lat, lng: patientInfo.lng }));
            dispatch(setAnalyticUsersClicked(false))
            dispatch(activateMarker({ id: patientInfo.id, disableHover: true }))
            dispatch(setPublicPinClicked(patientInfo.id))
        } else {
            //navigate(`/Conversations`, { state: { directNamePublic: patientInfo.name_public, directId: patientInfo.id } });
            navigate({
                pathname: "/Conversations", search: new URLSearchParams({ directId: patientInfo.id, directNamePublic: patientInfo.name_public, }).toString(),
            });
        }
    }

    // useEffect(() => {
    //     if (isSuccessSetChat && chatMode) {
    //         dispatch(setAnalyticUsersClicked(false))
    //         navigate("/Messages", { state: { chatAndUserData: setChatData } })
    //     }
    // }, [isSuccessSetChat, setChatData, navigate])

    return (
        <Stack
            sx={{
                border: '1px solid',
                borderRadius: 2,
                borderColor: '#EEEEEE',
                mb: compact ? 0 : 0.5,
                p: compact ? 1 : 1.5,
                py: compact ? 0.75 : undefined,
                width: '100%',
                cursor: 'pointer',
                transition: 'all 0.15s ease',
                '&:hover': { backgroundColor: '#F5F3FF', borderColor: '#E0DEFF' },
            }}
            alignItems={align}
            direction="column"
            onClick={handleProfileClick}
        >
            <Stack alignItems="center" direction="row" gap={0.5}>
                {chatMode && <ChatIcon sx={{ color: '#656EFF', fontSize: 18, mr: 0.5 }} />}
                <Tooltip title={chatMode ? "Start a chat" : "See Pin"} placement='top-start' arrow>
                    <LoadingButton
                        loading={isLoadingProfileLoggedIn || isLoadingSetChat}
                        onClick={(e) => { e.stopPropagation(); handleProfileClick(); }}
                        variant="text"
                        sx={{
                            p: 0,
                            minWidth: 0,
                            fontWeight: 600,
                            fontSize: compact ? 12 : 14,
                            color: '#1a1a2e',
                            textTransform: 'none',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            '&:hover': { backgroundColor: 'transparent', color: '#656EFF' },
                        }}
                    >
                        {patientInfo.name_public}
                    </LoadingButton>
                </Tooltip>
                {GetUserTypePin(patientInfo.type, { style: { height: compact ? 18 : 22, width: compact ? 18 : 22 } }).icon}
                <Chip
                    style={{ marginLeft: 'auto' }}
                    size="small"
                    label={(patientInfo.distance !== null && patientInfo.distance !== undefined) ? formattedNumber + ' mi' : "Unknown"}
                    sx={{ backgroundColor: '#EDE9FF', color: '#656EFF', fontWeight: 600, fontSize: compact ? 10 : 11, height: compact ? 18 : 20 }}
                />
            </Stack>
            {patientInfo.formattedsearchterm &&
                <Stack direction="row" alignItems="center" gap={0.25} sx={{ mt: compact ? 0.25 : 0.5 }}>
                    <PlaceIcon sx={{ fontSize: compact ? 11 : 13, color: '#BBBBBB', flexShrink: 0 }} />
                    <Typography variant="caption" sx={{ color: '#888', fontSize: compact ? 10 : undefined }} noWrap>
                        {patientInfo.formattedsearchterm}
                    </Typography>
                </Stack>
            }
            {patientInfo.variable &&
                <Typography variant="caption" sx={{ mt: 0.25, color: '#888' }}>
                    {`${patientInfo.variable} : ${patientInfo.value}`}
                </Typography>
            }
        </Stack>

    );
};

//{patientInfo.variable.toLowerCase().split("_").map((word : any) => word.charAt(0).toUpperCase() + word.slice(1)).join(" ") + " : " + patientInfo.value}

// {"address" in patientInfo &&
//     <Typography variant="caption" sx={{ pb: 1, color:'#777777' }}>
//         {patientInfo.address}
//     </Typography>
// }
// {"variable" in patientInfo &&
//     <Typography variant="body2" sx={{ pb: 1, color:'#777777' }}>
//         {patientInfo.variable.toLowerCase().split("_").map((word : any) => word.charAt(0).toUpperCase() + word.slice(1)).join(" ") + " : " + patientInfo.value}
//     </Typography>
// }
